import React from 'react'
import PropTypes from 'prop-types'

import LandingPageCategoriesContainer from './LandingPageCategoriesContainer'

function LandingPageCategories({ competitionSlug }) {
  const categoriesNumber = I18n.t(`competition.${competitionSlug}.categories.number`)
  const categoriesSections = I18n.t(`competition.${competitionSlug}.categories.landing_page`)

  return (
    <section className="content-section section--categories">
      <div className="container-fixed">
        <h2 className="content-section__title">Categories and prizes</h2>
        <p className="content-section__subtitle">
          Submit your artwork to one of the {categoriesNumber} Competition categories and win great prizes
        </p>

        {categoriesSections.map((section) => {
          return (
            <div key={section.slug}>
              <div className="content-subsection__title">{section.title}</div>
              <LandingPageCategoriesContainer
                competitionSlug={competitionSlug}
                activeSectionSlug={section.slug}
                categories={I18n.t(`competition.${competitionSlug}.categories.${section.slug}`)}
              />
            </div>
          )
        })}
      </div>
    </section>
  )
}

LandingPageCategories.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
}

export default LandingPageCategories
